import "./styles.scss";
import { useEffect, useState } from "react";

type CustomNumberInputProps = {
    value: number;
    min: number;
    max?: number;
    testId?: string;
    onChange: (...args: any) => void
    onBlur?: (...args: any) => void
    readOnly?: boolean
    showButtons?: boolean
}

export function CustomNumberInput({ value, min, max, onChange, testId = '', onBlur, readOnly = false, showButtons = true }: CustomNumberInputProps) {

    const [counter, setCounter] = useState(value ?? min);
    useEffect(() => { setCounter(value ?? min) }, [value, min])

    const increment = () => {
        if (!(counter === max)) {
            const _counter = counter + 1;
            setCounter(_counter);
            onChange(_counter);
        }
    };

    const decrement = () => {
        if (!(counter === min)) {
            const _counter = counter - 1;
            setCounter(_counter);
            onChange(_counter);
        }
    };

    const handleChange = (e) => {
        const currentValue = e.target.value;
        if (isNaN(parseInt(currentValue))) {
            setCounter(currentValue);
        } else {
            let _counter: number;
            if (min && currentValue < min) {
                _counter = min;
            } else if (max && currentValue > max) {
                _counter = max;
            } else {
                _counter = parseInt(currentValue);
            }

            onChange(_counter);
            setCounter(_counter);
        }
    };

    return (
        <div className="custom-number-input d-flex c-bd-200 justify-content-between c-w-fit">
            {button("-", decrement, readOnly)}
            <input
                data-testid={testId}
                readOnly={readOnly}
                type="number"
                min={min}
                max={max}
                onBlur={(ev) => { ev.preventDefault(); onBlur && onBlur(parseInt(ev.target.value)); }}
                className="d-flex input align-items-center justify-content-center c-w-fit"
                value={counter}
                onChange={handleChange}
            />
            {button("+", increment, readOnly)}
        </div>
    );
    //- -> Em dash (large hyphen)
    function button(elem: "+" | "-", onClick: () => void, readOnly = false) {
        const sideBorder = elem === "+" ? "border-left" : "border-right";
        const iconPath = elem === "+"
            ? "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
            : "M19 13H5v-2h14z";

        let isDisabled = true;

        if(elem === '+') {
            isDisabled = max === undefined ? false : counter >= max;
        } 
        
        if(elem === '-') {
            isDisabled = min === undefined ? false : counter <= min;
        }

        if (readOnly) {
            isDisabled = true;
        }

        if (!showButtons) {
            return <></>
        }

        return (
                <button
                    onClick={onClick}
                    disabled={isDisabled}
                    className={`${sideBorder} button px-1 c-bg-primary cp d-flex align-items-center justify-content-center`}
                >
                    <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill={isDisabled ? 'black' : 'white'}
                        aria-hidden="true"
                    >
                        <path d={iconPath} />
                    </svg>
                </button>
        );
    }
}
